export const APP_NAME = 'My  IABlue'
export const APP_DESCRIPTION = 'Assistente de Clientes do Mercado Phone'

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  CONFIRM_EMAIL: '/confirm-email',
  DASHBOARD: '/dashboard',
  CHAT: '/chat',
  CHANNELS: '/channels',
  CONVERSATIONS: '/conversations',
  WEBHOOK_LOGS: '/webhook-logs',
  ATTENDANCE_METRICS: '/attendance-metrics',
  ATTENDANCE_METRICS_MANAGEMENT: '/attendance-metrics/management',
  ATTENDANCE_METRICS_SNAPSHOTS: '/attendance-metrics/snapshots',
  ATTENDANCE_METRICS_SNAPSHOT_DETAIL: (id: string) => `/attendance-metrics/snapshot/${id}`,
  AI_SETTINGS: '/settings/my-iablue',
  KNOWLEDGE_EXTRACTION_SETTINGS: '/settings/knowledge-extraction',
  KNOWLEDGE_EXTRACTION_LOGS: '/settings/knowledge-extraction/logs',
  PROFILE: '/profile',
  KNOWLEDGE: '/knowledge',
} as const

export const API_ENDPOINTS = {
  AUTH: {
    SIGNIN: '/auth/signin',
    SIGNUP: '/auth/signup',
    CONFIRM_EMAIL: '/auth/confirm-email',
    ME: '/auth/me',
  },
  PATIENTS: '/patients',
  APPOINTMENTS: '/appointments',
  PAYMENTS: '/payments',
} as const

export const STORAGE_KEYS = {
  AUTH: 'my-iablue-auth',
  THEME: 'my-iablue-theme',
  KNOWLEDGE_EXTRACTION_LAST_RANGE: 'my-iablue-knowledge-extraction-last-range',
} as const

export const QUERY_KEYS = {
  AUTH: ['auth'],
  ME: ['auth', 'me'],
  PATIENTS: ['patients'],
  APPOINTMENTS: ['appointments'],
  PAYMENTS: ['payments'],
} as const

/**
 * Fixed ID for the My IABlue assistant
 * This is a singleton assistant that is seeded in the database
 */
export const MY_IABLUE_ASSISTANT_ID = '00000000-0000-0000-0000-000000000001'
